// Keys must match Collections::EmailTemplate.tones from the backend.
export const TONE_COLOR_BY_KEY = {
  friendly: '#2e7d32',
  second_notice: '#e65100',
  urgent: '#b71c1c',
} as const;

export type ToneKey = keyof typeof TONE_COLOR_BY_KEY;
